// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesDetailAction.js" company="Izenda">
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;
  var lifecycle = require('recompose').lifecycle;
  var setPropTypes = require('recompose').setPropTypes;
  var PropTypes = require('react').PropTypes;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.SecurityPoliciesConstant');

  var observer = require('mobx-react').observer;
  var commonMessage = require('share/messages/Izenda.CommonMessages');
  var SecurityPoliciesStore = require('logic/Izenda.SecurityPoliciesStore');
  const { curry, isEmpty, isNil, toNumber } = require('lodash/fp');

  var securityPoliciesDetailAction = compose(
    withProps({
      store: new SecurityPoliciesStore()
    }),
    withHandlers({
      onBlurFocusField: curry(onBlurFocusField),
      onChangeValueCheckbox: curry(onChangeValueCheckbox),
      onChangeSettingValueMinPasswordLength: curry(onChangeSettingValueMinPasswordLength),
      onChangeSettingValueMaxPasswordLength: curry(onChangeSettingValueMaxPasswordLength),
      onChangeRequiredValue: curry(onChangeRequiredValue),
      onChangeRequiredPositiveValue: curry(onChangeRequiredPositiveValue),
      onSave: curry(onSave),
      onCancel: curry(onCancel),
      getFieldValidateBeforeSave: curry(getFieldValidateBeforeSave)
    })
  );

  /**
   * on Blur Focus Field
   * @param  {object} props
   * @param  {array} validateField
   */
  function onBlurFocusField(props, validateField, e, _) {
    var valManager = props.validation;
    valManager.validate(validateField);
  }

  /**
   * onChange Value Check box
   * @param  {object} props
   * @param  {string} field
   * @param  {array} validateField
   * @param  {boolean} value
   */
  function onChangeValueCheckbox(props, field, value, e) {
    var model = props.store.model;
    if (!value) {
      props.validation.reset();
    }
    model.updateValueByKey(field, value);
  }

  /**
   * onChange Setting Value Min Password Length
   * @param  {object} props
   * @param  {string} field
   */
  function onChangeSettingValueMinPasswordLength(props, field, value, e) {
    var model = props.store.model;
    model.updateValueByKey(field, value);
    model.autoCalculateMinPasswordLength();
  }

  /**
   * onChange Setting Value Max Password Length
   * @param  {object} props
   * @param  {string} field
   */
  function onChangeSettingValueMaxPasswordLength(props, field, value, e) {
    var model = props.store.model;
    model.updateValueByKey(field, value);
    model.autoCalculateMaxPasswordLength();
  }

  /**
   * onChange Number Password Keep
   * @param  {object} props
   * @param  {string} field
   * @param  {number} requiredValue
   * @param  {string} value
   */
  function onChangeRequiredValue(props, field, requiredValue, value, e) {
    var model = props.store.model;
    if (isEmpty(value)) {
      model.updateValueByKey(field, value);
    } else {
      value = model.toNumber(value);
      value >= constants.REQUIRED_MIN_VALUE && value <= requiredValue && model.updateValueByKey(field, value);
    }
  }

  /**
   * onChange Required Positive Value
   * @param  {object} props
   * @param  {string} field
   * @param  {number} value
   */
  function onChangeRequiredPositiveValue(props, field, value, e) {
    props.store.model.updateValueByKey(field, value, constants.REQUIRED_MIN_POSITIVE_VALUE);
  }

  /**
   * Click Save Detail
   */
  function onSave(props, e) {
    var store = props.store;
    var loader = props.loader;
    var valManager = props.validation;
    var localization = props.localization;
    var needValidateFields = getFieldValidateBeforeSave(props);

    valManager.validate(needValidateFields).then(function(success) {
      if (success) {
        loader.startLoading();
        store
          .save()
          .then(function(result) {
            if (!isNil(result.messages)) {
              if (isEmpty(result.messages[0].key)) {
                props.store.alertMessage = {
                  type: 'error',
                  message: result.messages[0].messages[0]
                };
              } else {
                valManager.updateErrors(result.messages);
              }
            } else {
              this.setAlertMessage('success', localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
            }

            return null;
          })
          .finally(loader.endLoading.bind(loader));
      }
    });
  }

  /**
   * Click cancel Detail
   */
  function onCancel(props, e) {
    var loader = props.loader;
    var store = props.store;

    loader.startLoading();
    props.validation.reset();
    store.loadSecurityPoliciesDetail().finally(loader.endLoading.bind(loader));
  }

  /**
   * get Field Validate Before Save
   * @return {object}
   */
  function getFieldValidateBeforeSave(props) {
    var needValidateFields = [];
    var model = props.store.model;
    model.passwordLength && needValidateFields.push('minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght');
    model.numberSpecialCharacters &&
      needValidateFields.push('minNumberOfSpecialCharacter', 'maxNumberOfSpecialCharacter');
    model.numberUppercaseCharacters &&
      needValidateFields.push('minNumberOfUppercaseCharacter', 'maxNumberOfUppercaseCharacter');
    model.numberLowercaseCharacters &&
      needValidateFields.push('minNumberOfLowercaseCharacter', 'maxNumberOfLowercaseCharacter');
    model.numberNumericCharacters &&
      needValidateFields.push('minNumberOfNumericCharacte', 'maxNumberOfNumericCharacter');
    model.numberNumericCharacters &&
      needValidateFields.push('minNumberOfNumericCharacte', 'maxNumberOfNumericCharacter');
    model.maxNumberSequentialRepeated && needValidateFields.push('maxNumberOfRepeatSequential');
    model.passwordAge && needValidateFields.push('minNumberOfPasswordAge', 'maxNumberOfPasswordAge');
    model.notifyUser && needValidateFields.push('notifyUseDuring');
    model.enforcePasswordHistory && needValidateFields.push('numberOfPasswordToKeep');
    model.passwordLinkValidityChecked && needValidateFields.push('passwordLinkValidit');
    model.useSecurityQuestions && needValidateFields.push('numberOfQuestionProfile');
    model.useSecurityQuestions &&
      toNumber(model.numberOfQuestionProfile) !== 0 &&
      needValidateFields.push('numberOfQuestionResetPassword');
    model.numberFailedLogonAttemptsAllowed && needValidateFields.push('numberOfFailedLogonAllowed');
    model.numberFailedSecurityQuestionAttemptsAllowed && needValidateFields.push('numberOfFailedAnswerAllowed');
    (toNumber(model.numberOfFailedAnswerAllowed) === 0 || toNumber(model.numberOfFailedLogonAllowed) === 0) &&
      needValidateFields.push('lockoutPeriod');

    return needValidateFields;
  }

  module.exports = securityPoliciesDetailAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetailAction.js